import type { DocNode } from '@atlaskit/adf-schema';

export const appendADFContent = (content: DocNode, suggestionContent: string): DocNode => {
	const updatedContent = Array.isArray(content.content) ? content.content : [content.content];
	// Append the new paragraph node
	updatedContent.push({
		type: 'paragraph',
		content: [
			{
				type: 'text',
				text: suggestionContent,
			},
		],
	});

	// Return the updated DocNode
	return {
		...content,
		content: updatedContent,
	};
};
